import { render, staticRenderFns } from "./SuppEditAppr.vue?vue&type=template&id=119a857a&scoped=true&"
import script from "./SuppEditAppr.vue?vue&type=script&lang=js&"
export * from "./SuppEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119a857a",
  null
  
)

export default component.exports